export const loanCarSaleOption = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: true,
    searchMenuSpan: 6,
    searchLabelWidth: 100,
    labelWidth: 150,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    dialogType: 'drawer',
    dialogClickModal: false,
    column: [{
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        {
            label: "进件编号",
            prop: "businessCode",
            search: true,
            hide: true,
            display: false,
        },
        {
            label: "进件编号",
            prop: "code",
            search: false,
            display: true,
            searchOrder: 555,
        },
        {
            label: "所属代理商",
            prop: "busssinessDeptName",
            search: false,
            type: "select",
            display: true,
        },
        {
            label: "产品类型",
            prop: "rentType",
            search: false,
            searchMultiple: true,
            searchClearable: true,
            type: "select",
            display: false,
            dicData: [],
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            search: true,
            searchMultiple: true,
            searchClearable: true,
            type: "select",
            display: false,
            hide: true,
            dicData: [],
            searchOrder: 888,
        },
        {
            label: "租赁人",
            search: false,
            prop: "tenantName",
        },
        {
            label: "租赁人",
            search: true,
            prop: "name",
            hide: true,
            searchOrder: 777,
        },
        {
            label: "手机号",
            prop: "tenantPohone",
        },
        {
            label: "租赁金额",
            prop: "tenantAmount",
        },
        {
            label: "每月租金",
            prop: "monthlyAmount",
        },
        {
            label: "车牌号",
            prop: "firstNumber",
            search: false,
        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            hide: true,
            search: true,
            searchOrder: 666,
        },
        {
          label: "客户期数",
          prop: "currentTenancy",
          type: "input",
          formatter: (val, value, label) => {
              return value ? (value + "/" + val['tenancy']) : "-";
          },
      },
        {
            label: "卖车款",
            prop: "sellCarAmount",
            search: false,
        },
    ],
}
